import { render, staticRenderFns } from "./DashDemandPrepList.vue?vue&type=template&id=add90312&scoped=true&"
import script from "./DashDemandPrepList.vue?vue&type=script&lang=js&"
export * from "./DashDemandPrepList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add90312",
  null
  
)

export default component.exports